import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as MOCKED_IP from './mockIp.json';
import * as MOCKED_DOMAINS from './mockFields.json';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class IpService {

  private ipifyUrl = environment.ipifyUrl;

  constructor(private http: HttpClient) { }

  getIpAddress() {
    return this.http.get<{ ip: string }>(this.ipifyUrl).pipe(
      catchError(error => {
        console.warn('No se pudo obtener la IP real, usando IP mockeada:', error);
        return of(MOCKED_IP);
      })
    );
  }

  getDomains(): any {
    const model = JSON.parse(JSON.stringify(MOCKED_DOMAINS));
    const ciencuadras = model[0];
    const segurosbolivar = model[1];
    const serviciosbolivar = model[2];
    const doctoraki = model[3];
    const jelpit = model[4];

    const newModel = [];

    newModel.push(ciencuadras);
    newModel.push(segurosbolivar);
    newModel.push(serviciosbolivar);
    newModel.push(doctoraki);
    newModel.push(jelpit);

    return newModel;
  }
}